import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import MetaOpenGraph from 'marketplace-ui-common/components/elements/MetaOpenGraph';
import MetaTwitter from 'marketplace-ui-common/components/elements/MetaTwitter';
import { useCanonicalUrl } from '../../../common/hooks/useCanonicalUrl';
import { useSocialScreenshotUrl } from '../../../hooks/useSocialScreenshotUrl';

function StorefrontSocialSharing({
  description,
  title
}) {
  const canonicalUrl = useCanonicalUrl();
  const socialScreenshotUrl = useSocialScreenshotUrl();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MetaTwitter, {
      name: "card"
    }), /*#__PURE__*/_jsx(MetaTwitter, {
      name: "site"
    }), /*#__PURE__*/_jsx(MetaTwitter, {
      name: "image",
      content: socialScreenshotUrl
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "type"
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "url",
      content: canonicalUrl
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "title",
      content: title
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "description",
      content: description
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "image",
      content: socialScreenshotUrl
    })]
  });
}

export default StorefrontSocialSharing;